import configService from './configService';
import { MpnProvider, MpnProviderSearchCriteria, MpnProviderSearchResponse } from '@wcp-ca-mpn/shared';

interface RequestOptions extends RequestInit {
  headers?: Record<string, string>;
}

/**
 * Service for making API calls
 */
class ApiService {

    async request<T>(endpoint: string, options: RequestOptions = {}): Promise<T> {
        const apiUrl = await configService.get('API_URL', 'http://localhost:4000');
        const apiTimeout = await configService.get('API_TIMEOUT', 30000);
        const debugMode = await configService.get('DEBUG_MODE', false);

        const url = `${apiUrl}/${endpoint}`;

        const defaultOptions = {
            headers: {
                'Content-Type': 'application/json',
            }
        };

        const fetchOptions = {
            ...defaultOptions,
            ...options,
            headers: {
                ...defaultOptions.headers,
                ...(options.headers || {})
            }
        };

        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), apiTimeout);

            const response = await fetch(url, {
                ...fetchOptions,
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            if (debugMode) {
                console.error(`API request failed: ${endpoint}`, error);
            }
            throw error;
        }
    }

    async searchProviders(criteria: MpnProviderSearchCriteria): Promise<MpnProviderSearchResponse> {
        return this.request('api/mpnproviders', {
            method: 'POST',
            body: JSON.stringify(criteria)
        });
    }

    async getProvider(providerId: string): Promise<MpnProvider> {
        return this.request(`api/mpnproviders/${providerId}`);
    }
}

const apiService = new ApiService();
export default apiService;
